import nexusProcurementHtml from '@/assets/Artifacts/nexus-procurement.html?raw'
import nexusCrmTestReportMarkdown from '@/assets/Artifacts/nexus-crm-test-report.md?raw'
import interfaceManagementCapability from './content/interface-management-capability.md?raw'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import { buildFileWriteNarration, buildStepNarration } from './stepNarrationCopy.js'
import {
  NEXUS_APPLICATION_ACCESS_TABLE,
  NEXUS_CONNECTED_APP_BLOCKS,
  NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
} from './nexusIntegrationsDemo.js'
import {
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD,
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL,
  ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN,
} from './zohoCrmIntegrationDemoContent.js'

export const WEBSITE_CRM_PROCESS_EXECUTION_TABLE_DATA = [
  {
    Phase: 'Website Build',
    'Execution Step': 'Scaffold nexus-b2b-site + HTML artifact',
    Result: '2,785-line procurement site opened in preview',
    Status: '✅ PASS',
  },
  {
    Phase: 'Website Build',
    'Execution Step': 'Static build + preview panel',
    Result: 'dist/index.html · 248 kB',
    Status: '✅ PASS',
  },
  {
    Phase: 'CRM Integration',
    'Execution Step': 'FastAPI Salesforce + HubSpot + Procurify layer (19 files)',
    Result: '/api/v1/salesforce/* · /api/v1/hubspot/* · /api/v1/procurify/* live',
    Status: '✅ PASS',
  },
  {
    Phase: 'CRM Integration',
    'Execution Step': 'Playwright demo-user checkout',
    Result: '1 passed · 8.4s',
    Status: '✅ PASS',
  },
  {
    Phase: 'CRM Integration',
    'Execution Step': 'Live lead + webhook trigger',
    Result: 'Lead ID 58930100001234567 · wh_8f3a2c',
    Status: '✅ PASS',
  },
  {
    Phase: 'Email & Payments',
    'Execution Step': 'Stripe + Mailchimp connection check',
    Result: 'Applications already connected',
    Status: '✅ PASS',
  },
]
